var _circle, _rect, _rect2, _rect3, _path, _path2, _path3, _path4, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _path5, _path6, _path7, _path8, _ellipse, _path9, _rect11, _path10, _path11, _ellipse2, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNoCandidates(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 104,
    height: 104,
    viewBox: "0 0 104 104",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 52,
    cy: 52,
    r: 52,
    fill: "#F2FBFD"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 21.1626,
    y: 36.3013,
    width: 42.651,
    height: 52.129,
    rx: 6.96674,
    transform: "rotate(-5.72562 21.1626 36.3013)",
    fill: "#CAF0F8",
    fillOpacity: 0.5
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 55.5586,
    y: 31.9893,
    width: 38.0086,
    height: 46.455,
    rx: 6.20844,
    transform: "rotate(16.8433 55.5586 31.9893)",
    fill: "#CAF0F8",
    fillOpacity: 0.5
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 52.5924,
    y: 24.0471,
    width: 40.2768,
    height: 49.4137,
    rx: 6.2963,
    transform: "rotate(16.7054 52.5924 24.0471)",
    fill: "white",
    stroke: "#90E0EF",
    strokeWidth: 0.839506
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M58.3368 52.8911C59.1426 50.206 61.9726 48.6826 64.6577 49.4884L67.0887 50.218C69.7738 51.0238 71.2973 53.8538 70.4914 56.5389L58.3368 52.8911Z",
    fill: "#00B4D8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M63.3453 43.2646C63.1841 43.8017 63.4888 44.3676 64.0259 44.5288L63.9529 44.7719C63.5584 46.0865 64.0228 47.4546 65.0219 48.2736L64.6574 49.4881L64.6817 49.4954C64.6422 49.5692 64.6094 49.648 64.5844 49.7312C64.383 50.4025 64.7638 51.11 65.4351 51.3115C66.1064 51.5129 66.8139 51.1321 67.0154 50.4608C67.0403 50.3775 67.0564 50.2937 67.064 50.2104L67.0883 50.2177L67.4528 49.0031C68.7378 48.8696 69.8788 47.9834 70.2733 46.6688L70.3463 46.4257C70.8833 46.5868 71.4493 46.2822 71.6105 45.7451C71.7716 45.2081 71.4669 44.6421 70.9299 44.4809C70.9017 44.4725 70.8734 44.4653 70.8451 44.4594C70.936 42.9654 69.9949 41.5504 68.4993 41.1016C67.0037 40.6527 65.4389 41.3156 64.6922 42.6128C64.6653 42.6021 64.6377 42.5925 64.6095 42.5841C64.0725 42.4229 63.5065 42.7276 63.3453 43.2646Z",
    fill: "#ADE8F4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M68.1829 46.5714C68.0861 46.8937 67.8653 47.1644 67.5689 47.324C67.2726 47.4835 66.925 47.5188 66.6026 47.422C66.2803 47.3253 66.0096 47.1045 65.85 46.8081C65.6905 46.5117 65.6552 46.1642 65.752 45.8418L66.9674 46.2066L68.1829 46.5714Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M65.2421 42.244L64.5126 44.675L64.0264 44.529L65.1937 40.6396L65.455 40.718C66.2912 39.722 67.6691 39.2626 68.9938 39.6601L72.0979 40.5917L71.0765 43.995L71.0764 43.995L70.3468 46.4259L69.8606 46.28L70.5902 43.8491L65.2421 42.244Z",
    fill: "#03045E"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 50.0229,
    y: 54.106,
    width: 27.4108,
    height: 1.52282,
    transform: "rotate(16.7054 50.0229 54.106)",
    fill: "#EAEAF1"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 49.0015,
    y: 57.5093,
    width: 10.6598,
    height: 1.52283,
    transform: "rotate(16.7054 49.0015 57.5093)",
    fill: "#EAEAF1"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 47.688,
    y: 61.8848,
    width: 8.12173,
    height: 3.55325,
    rx: 1.67901,
    transform: "rotate(16.7054 47.688 61.8848)",
    fill: "#ADE8F4"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 56.9253,
    y: 64.6572,
    width: 8.12173,
    height: 3.55326,
    rx: 1.67901,
    transform: "rotate(16.7054 56.9253 64.6572)",
    fill: "#ADE8F4"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    width: 8.12172,
    height: 3.55326,
    rx: 1.67901,
    transform: "matrix(0.957795 0.287451 -0.28745 0.957796 66.1631 67.4292)",
    fill: "#ADE8F4"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 25.6885,
    y: 30.5713,
    width: 40.6351,
    height: 53.4451,
    rx: 6.75813,
    transform: "rotate(-5.72562 25.6885 30.5713)",
    fill: "#03045E",
    fillOpacity: 0.1
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 14.8366,
    y: 26.3775,
    width: 47.9767,
    height: 58.8605,
    rx: 7.5,
    transform: "rotate(-6.371 14.8366 26.3775)",
    fill: "white",
    stroke: "#90E0EF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M36.292 37.7765C36.1623 36.615 36.9988 35.5682 38.1603 35.4385L41.7658 35.0359C42.9274 34.9062 43.9742 35.7427 44.1039 36.9043C44.2336 38.0659 43.3971 39.1127 42.2355 39.2424L38.63 39.6449C37.4684 39.7746 36.4217 38.9381 36.292 37.7765Z",
    fill: "#03045E"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M34.8917 41.5832C34.6508 39.426 36.2043 37.482 38.3615 37.2411C40.5187 37.0003 42.4627 38.5538 42.7036 40.711L42.7372 41.0114L34.9252 41.8837L34.8917 41.5832Z",
    fill: "#03045E"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M45.7081 40.3752C45.4672 38.218 43.5232 36.6645 41.366 36.9054C39.2088 37.1462 37.6553 39.0902 37.8962 41.2474L37.9297 41.5479L45.7416 40.6757L45.7081 40.3752Z",
    fill: "#03045E"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M34.8584 41.2827L45.6749 40.075L46.7484 49.6897L35.9319 50.8974L34.8584 41.2827Z",
    fill: "#03045E"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 40.7684,
    cy: 42.4479,
    rx: 3.93023,
    ry: 4.83721,
    transform: "rotate(-6.371 40.7684 42.4479)",
    fill: "#ADE8F4"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M41.938 44.7509C41.9647 44.9899 41.8953 45.2298 41.7452 45.4177C41.595 45.6056 41.3763 45.7262 41.1373 45.7529C40.8982 45.7796 40.6583 45.7102 40.4704 45.56C40.2825 45.4099 40.1619 45.1912 40.1353 44.9521L41.0366 44.8515L41.938 44.7509Z",
    fill: "white"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    width: 3.02326,
    height: 1.81395,
    transform: "matrix(0.993824 -0.110965 0.110966 0.993824 39.7358 46.8223)",
    fill: "#ADE8F4"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M36.3257 38.0767L41.7339 37.4728C41.9563 39.4641 40.5223 41.2585 38.531 41.4809L36.7283 41.6822L36.3257 38.0767Z",
    fill: "#03045E"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M34.5987 55.3051C34.2281 51.9863 36.6181 48.9955 39.9369 48.6249L42.3406 48.3566C45.6593 47.986 48.6501 50.376 49.0207 53.6948L34.5987 55.3051Z",
    fill: "#0096C7"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 41.4728,
    cy: 48.7574,
    rx: 1.51163,
    ry: 1.51163,
    transform: "rotate(-6.371 41.4728 48.7574)",
    fill: "#ADE8F4"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 39.9312,
    y: 37.6743,
    width: 3.6279,
    height: 1.81395,
    transform: "rotate(-6.37101 39.9312 37.6743)",
    fill: "#03045E"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 26.0547,
    y: 60.5176,
    width: 32.6512,
    height: 1.81395,
    transform: "rotate(-6.371 26.0547 60.5176)",
    fill: "#EAEAF1"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 26.5244,
    y: 64.7241,
    width: 12.6977,
    height: 1.81395,
    transform: "rotate(-6.37101 26.5244 64.7241)",
    fill: "#EAEAF1"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 27.1284,
    y: 70.1323,
    width: 9.67442,
    height: 4.23255,
    rx: 2,
    transform: "rotate(-6.371 27.1284 70.1323)",
    fill: "#ADE8F4"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 38.5459,
    y: 68.8574,
    width: 9.67442,
    height: 4.23255,
    rx: 2,
    transform: "rotate(-6.371 38.5459 68.8574)",
    fill: "#ADE8F4"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 49.9634,
    y: 67.5825,
    width: 9.67441,
    height: 4.23255,
    rx: 2,
    transform: "rotate(-6.371 49.9634 67.5825)",
    fill: "#ADE8F4"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoCandidates);
export default __webpack_public_path__ + "static/media/NoCandidates.fae4c03e5dfdaaea0db42461476bf770.svg";
export { ForwardRef as ReactComponent };